import { errorNotification } from '../../../shared/store/notificationActions';

export const alertNotification = message => errorNotification(
  message,
  {
    timeOut: 0,
    showCloseButton: true,
    removeOnHover: false,
  }
);
